//
// Module for the Death Benefit Setup wizard's Initiate Step Recipients Grid (partial)
//
rs.module("participant/benefit/setup/death/wizard/initiatesteprecipientsgrid",

    ["controls/components/event-banner"],

    function (eventBanner) {

        // Initialize the module
        function initialize(grid, recipientsSelected) {

            // Get the wizard's next button and disable it when grid first displays (if a recipient record is not already selected)
            var wizardNextButton = $(`[data-wizard]`).js("_next");
            wizardNextButton.setDisabled(!recipientsSelected);

            var _executeSelectionChanged;

            if (grid) {

                grid.selectionChanged(function (values, rows) {

                    // This handler fires when the grid is first rendered, but we don't want to react in that case.
                    // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked.
                    if (_executeSelectionChanged) {

                        // clear any messages in the message banner
                        eventBanner.removeAllMessages();

                        // Enable the wizard's next button                    
                        wizardNextButton.setDisabled(values.length == 0);
                    }

                    _executeSelectionChanged = true;
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);